module.exports = __webpack_public_path__ + "static/media/avatar_boar.880eba4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_boar.png
// module id = 368
// module chunks = 0